import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button, TableRow, TableHead, TableBody, TableCell } from '@mui/material';

import { SortableContainer } from 'react-sortable-hoc';

import NewLink from './NewLink';
import ListEditRow from './ListEditRow';
import LinkEditRow from './LinkEditRow';

import Node from '../../../../../common/Node';
import FullScreenDialog from '../../../../../common/FullScreenDialog';
import TrplSelect from '../../../../../common/TrplControls/TrplSelect';

import PredicateChain from '../../../../../common/PredicateChain';

import TableEdit from '../../TableEdit/TableEdit';
import TrplFormEdit from '../TrplFormEdit';

import { updateJels } from '../../../../../reducer/jelsReducer';

const RestrictionsSortableList = SortableContainer(
  ({
    form,
    items,
    classes,
    modalData,
    setupRbox,
    formConcepts,
    addInnerRstCb,
    removeInnerRst,
    openFrmEditModal,
    isPidsChainDuplicate,
    onGroupRstFieldChange,
    onRemoveRstFromGroupClick,
  }) => {
    return (
      <TableBody>
        {items.map((item, index) => {
          return (
            <ListEditRow
              item={item}
              form={form}
              index={index}
              classes={classes}
              itemIndex={index}
              setupRbox={setupRbox}
              modalData={modalData}
              formConcepts={formConcepts}
              rowIndex={modalData.rowIndex}
              addInnerRstCb={addInnerRstCb}
              removeInnerRst={removeInnerRst}
              groupIndex={modalData.groupIndex}
              openFrmEditModal={openFrmEditModal}
              isPidsChainDuplicate={isPidsChainDuplicate}
              onGroupRstFieldChange={onGroupRstFieldChange}
              key={(item && item.id) || (item && item.pid) || index}
              onRemoveRstFromGroupClick={onRemoveRstFromGroupClick}
            />
          );
        })}
      </TableBody>
    );
  }
);

const LinksSortableList = SortableContainer(
  ({
    tbls,
    frms,
    items,
    jelData,
    classes,
    setupRbox,
    modalData,
    onRstDragEnd,
    addGroupLink,
    selectedGroup,
    removeGroupLink,
    openFrmEditModal,
    openTblEditModal,
    onGroupLinkChange,
    onGroupFieldChange,
  }) => {
    return (
      <TableBody>
        {items.map((item, index) => {
          return (
            <LinkEditRow
              key={index}
              link={item}
              index={index}
              jelData={jelData}
              classes={classes}
              linkIndex={index}
              setupRbox={setupRbox}
              onRstDragEnd={onRstDragEnd}
              rowIndex={modalData.rowIndex}
              groupIndex={modalData.groupIndex}
              removeGroupLink={removeGroupLink}
              openTblEditModal={openTblEditModal}
              openFrmEditModal={openFrmEditModal}
              onGroupLinkChange={onGroupLinkChange}
            />
          );
        })}

        <NewLink
          tbls={tbls}
          frms={frms}
          classes={classes}
          group={selectedGroup}
          addGroupLink={addGroupLink}
          rowIndex={modalData.rowIndex}
          groupIndex={modalData.groupIndex}
          openTblEditModal={openTblEditModal}
          openFrmEditModal={openFrmEditModal}
          onGroupFieldChange={onGroupFieldChange}
        />
      </TableBody>
    );
  }
);

class TrplFormEditModal extends Component {
  state = {
    editFrmModal: {
      data: {},
      isOpened: false,
    },
    editTblModal: {
      data: {},
      isOpened: false,
    },
    addItemType: 'predicate',
    addPidConcept: null,
  };

  componentDidMount = () => {
    const { formConcepts } = this.props;

    const addPidConcept = Object.keys(formConcepts).length ? Object.keys(formConcepts)[0] : null;

    this.setState({ addPidConcept });
  }

  handleSortStart = ({ node }) => {
    const tds = document.getElementsByClassName(this.props.classes.draggableItemHelper)[0].childNodes;
    node.childNodes.forEach((node, idx) => (tds[idx].style.width = `${node.offsetWidth}px`));
  };

  openTblEditModal = (rowIndex, groupIndex, itemIndex, data) => {
    const editTblModal = { ...this.state.editTblModal };

    const newTable = {
      concept: 0,
      title: '',
      show_pids: [],
      sort_pid: '',
      sort_by: '',
      rowsToShow: 50,
    };

    editTblModal.isOpened = true;
    editTblModal.rowIndex = rowIndex;
    editTblModal.groupIndex = groupIndex;
    editTblModal.itemIndex = itemIndex;
    editTblModal.data = data || { ...newTable };

    this.setState({ editTblModal });
  };

  openFrmEditModal = (rowIndex, groupIndex, itemIndex, data, isObjectForm) => {
    const newFrm = {
      concept: null,
      title: '',
      groups: [],
    };
    
    const editFrmModal = {
      ...this.state.editFrmModal,
      isOpened: true,
      rowIndex,
      groupIndex,
      itemIndex,
      data: { ...newFrm, ...data },
      isObjectForm,
    };

    this.setState({ editFrmModal });
  };

  render() {
    const { addItemType, editTblModal, editFrmModal, addPidConcept } = this.state;

    const {
      form,
      setup,
      classes,
      modalData,
      setupRbox,
      modalIndex,
      formConcepts,
      deepCopyView,
      addGroupLink,
      onRstDragEnd,
      selectedGroup,
      onLinkDragEnd,
      addInnerRstCb,
      removeInnerRst,
      removeGroupLink,
      setCreatedJelLink,
      setCreatedJelForm,
      onGroupLinkChange,
      onGroupFieldChange,
      toggleRstEditModal,
      onCopyViewBtnClick,
      isPidsChainDuplicate,
      onGroupRstFieldChange,
      onGroupRstSelectChange,
      onRemoveRstFromGroupClick,
      onGroupComponentFieldChange,
    } = this.props;

    const currentModalIndex = modalIndex ? modalIndex + 1 : 1;

    const nodeSelectValues = Object.keys(formConcepts);

    return (
      <FullScreenDialog
        title={'Group edit - ' + form.title + '|' + form.id}
        modalIndex={currentModalIndex - 1}
        isOpen={modalData.isOpened}
        onClose={() => {
          toggleRstEditModal(null, null, 'list', false);
        }}
      >
        <React.Fragment>
          <FullScreenDialog
            modalIndex={currentModalIndex}
            onClose={() => {
              this.setState({
                editFrmModal: {
                  isOpened: false,
                  data: {},
                },
              });

              this.props.updateJels();
            }}
            isOpen={editFrmModal.isOpened}
            disableContainerPadding={true}
            title={
              (editFrmModal.data.id && !isNaN(editFrmModal.data.id))
                ? `Form edit - ${editFrmModal.data.title} | ${editFrmModal.data.id}`
                : 'Form create'
            }
          >
            <TrplFormEdit
              modalIndex={currentModalIndex + 1}
              key={editFrmModal.data.title}
              classes={classes}
              parentJelId={form.id}
              form={editFrmModal.data}
              dashboard={editFrmModal.data}
              deepCopyView={deepCopyView}
              onCopyViewBtnClick={onCopyViewBtnClick}
              setParentJel={(id) => {
                if (editFrmModal.isObjectForm) {
                  setCreatedJelForm(id, editFrmModal.rowIndex, editFrmModal.groupIndex, editFrmModal.itemIndex)
                } else {
                  setCreatedJelLink(id, editFrmModal.rowIndex, editFrmModal.groupIndex, editFrmModal.itemIndex);
                }
              }}
            />
          </FullScreenDialog>
          
          {modalData.isOpened && selectedGroup.items && modalData.type === 'list' ? (
            <div>
              <Table className={classes.mb10}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tCell} style={{ width: '20px' }} />
                    <TableCell className={classes.tCell}>
                      Title
                    </TableCell>

                    <TableCell className={classes.tCell}>
                      Hide title
                    </TableCell>

                    <TableCell className={classes.tCell}>
                      Editable
                    </TableCell>

                    <TableCell className={classes.tCell}>
                      Required
                    </TableCell>

                    <TableCell className={classes.tCell}>
                      Concept
                    </TableCell>

                    <TableCell className={classes.tCell}>
                      Component
                    </TableCell>

                    <TableCell className={classes.tCell}>
                      Widget type
                    </TableCell>

                    <TableCell className={classes.tCell}/>

                    <TableCell className={classes.tCell}/>

                    <TableCell className={classes.tCell}/>

                    <TableCell className={classes.tCell} style={{ width: '50px'}}>
                      Optional
                    </TableCell>
                  </TableRow>
                </TableHead>

                <RestrictionsSortableList
                  form={form}
                  setup={setup}
                  useDragHandle
                  classes={classes}
                  modalData={modalData}
                  setupRbox={setupRbox}
                  formConcepts={formConcepts}
                  addInnerRstCb={addInnerRstCb}
                  removeInnerRst={removeInnerRst}
                  onSortStart={this.handleSortStart}
                  onSortEnd={({ oldIndex, newIndex }) => {
                    onRstDragEnd(oldIndex, newIndex);
                  }}
                  items={selectedGroup.items}
                  openFrmEditModal={this.openFrmEditModal}
                  helperClass={classes.draggableItemHelper}
                  isPidsChainDuplicate={isPidsChainDuplicate}
                  onGroupRstFieldChange={onGroupRstFieldChange}
                  onRemoveRstFromGroupClick={onRemoveRstFromGroupClick}
                />
              </Table>

              <div className={classes.alignEnd}>
                <div className={`${classes.mr10} ${classes.w200}`}>
                  <TrplSelect
                    title="Type"
                    margin="none"
                    complicatedValues
                    values={[
                      { title: 'Predicate', value: 'predicate' },
                      { title: 'Function', value: 'function' },
                      { title: 'Custom', value: 'custom' },
                    ]}
                    value={addItemType || 'predicate'}
                    onChange={(e) => {
                      this.setState({ addItemType: e.target.value });
                    }}
                  />
                </div>

                {addItemType === 'predicate' || addItemType === 'custom' ?
                  <div className={`${classes.alignCenter} ${classes.mr10}`} style={{ marginBottom: '1px' }}>
                    {addPidConcept && formConcepts[addPidConcept] ?
                      <div className={classes.mr10}>
                        <Node
                          isLink
                          size="xs"
                          nodes={setupRbox}
                          nodeId={formConcepts[addPidConcept]}
                          node={setupRbox[formConcepts[addPidConcept]]}
                        />
                      </div>
                    : null}
                    <TrplSelect
                      margin="none"
                      values={nodeSelectValues}
                      value={addPidConcept || nodeSelectValues[0]}
                      onChange={(e) => this.setState({ addPidConcept: e.target.value })}
                    />
                  </div>
                : null}

                {!formConcepts[addPidConcept] ? null : addItemType === 'predicate' ? (
                  <div className={classes.mt20} style={{ width: '100%' }}>
                    <PredicateChain
                      mode="edit"
                      disableChain
                      ancestor={formConcepts[addPidConcept]}
                      addInnerRstCb={({ newSelected }) => {
                        onGroupRstSelectChange(modalData.rowIndex, modalData.groupIndex, newSelected[0], addPidConcept);
                      }}
                    />
                  </div>
                ) : addItemType === 'custom' ? (
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    style={{
                      marginTop: '17px',
                    }}
                    onClick={() => {
                      onGroupComponentFieldChange(modalData.rowIndex, modalData.groupIndex, 'custom', addPidConcept);
                    }}
                  >
                    Add custom
                  </Button>
                ) :
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    style={{
                      marginTop: '17px',
                    }}
                    onClick={() => {
                      onGroupComponentFieldChange(modalData.rowIndex, modalData.groupIndex, 'function');
                    }}
                  >
                    Add function
                  </Button>
                }
              </div>
              <div style={{ height: '300px' }} />
            </div>
          ) : modalData.isOpened && modalData.type === 'links' && (
            <div>
              <FullScreenDialog
                modalIndex={currentModalIndex}
                onClose={() => {
                  this.setState({
                    editTblModal: {
                      isOpened: false,
                      data: {},
                    },
                  });

                  this.props.updateJels();
                }}
                isOpen={editTblModal.isOpened}
                disableContainerPadding={true}
                title={
                  editTblModal.data.id
                    ? `Table edit - ${editTblModal.data.title} | ${editTblModal.data.id}`
                    : 'Table create'
                }
              >
                <TableEdit
                  modalIndex={currentModalIndex + 1}
                  parentJelId={form.id}
                  settings={editTblModal.data}
                  setParentJel={(id) => {
                    setCreatedJelLink(id, editTblModal.rowIndex, editTblModal.groupIndex, editTblModal.itemIndex);
                  }}
                  deepCopyView={deepCopyView}
                  onCopyViewBtnClick={onCopyViewBtnClick}
                />
              </FullScreenDialog>

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tCell} style={{ width: '50px' }} />
                    <TableCell className={classes.tCell}>Title</TableCell>
                    <TableCell className={classes.tCell}>Link</TableCell>
                    <TableCell className={classes.tCell}>Open in new tab</TableCell>
                    <TableCell className={classes.tCell} style={{ width: '50px' }}>Filter/Sort</TableCell>
                    <TableCell className={classes.tCell}>Table/form</TableCell>
                  </TableRow>
                </TableHead>

                <LinksSortableList
                  useDragHandle
                  classes={classes}
                  modalData={modalData}
                  setupRbox={setupRbox}
                  formConcepts={formConcepts}
                  onRstDragEnd={onRstDragEnd}
                  items={selectedGroup.links}
                  selectedGroup={selectedGroup}
                  removeGroupLink={removeGroupLink}
                  onSortStart={this.handleSortStart}
                  openFrmEditModal={this.openFrmEditModal}
                  openTblEditModal={this.openTblEditModal}
                  onGroupFieldChange={onGroupFieldChange}
                  onSortEnd={({ oldIndex, newIndex }) => {
                    onLinkDragEnd(oldIndex, newIndex);
                  }}
                  addGroupLink={addGroupLink}
                  onGroupLinkChange={onGroupLinkChange}
                  helperClass={classes.draggableItemHelper}
                />
              </Table>
            </div>
          )}
        </React.Fragment>
      </FullScreenDialog>
    );
  }
}

export default connect(null, { updateJels })(TrplFormEditModal);
